import { Link } from "@tanstack/react-router"
import { Lock } from "@phosphor-icons/react"

import { Button } from "~/components/reusable/Button"
import HakiFace from "~/components/reusable/HakiFace"
import { useUser } from "~/providers/userProvider"
import { formatName } from "~/utils/namingUtils"

export function HakiDataAccessGateContent({ faceSize = 40 }: { faceSize?: number }) {
  const { permissions } = useUser()
  return (
    <>
      <div className="relative">
        <HakiFace size={faceSize} working animated />
        <div className="absolute -bottom-1 -right-1 flex size-5 items-center justify-center rounded-full bg-base text-fg-base shadow-card-rest ring-2 ring-base">
          <Lock size={10} weight="fill" />
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <div className="text-fg-base font-semibold">Haki needs data access</div>
        <div className="text-fg-muted text-sm">
          Haki answers questions about your {formatName("sale", true)}, inventory, and products, so
          it only works when Haki is allowed to read your data. This is currently turned off for
          your organization.
          {permissions.canAdminister
            ? ' Enable "Allow Haki to read your data" to get started.'
            : ' Ask an admin to enable "Allow Haki to read your data" under Settings → Haki AI.'}
        </div>
      </div>
      {permissions.canAdminister && (
        <Button asChild size="sm">
          <Link to="/settings/ai">Open Haki AI settings</Link>
        </Button>
      )}
    </>
  )
}
